import { render, staticRenderFns } from "./AppointmentProgress.vue?vue&type=template&id=15a45290"
import script from "./AppointmentProgress.vue?vue&type=script&lang=js"
export * from "./AppointmentProgress.vue?vue&type=script&lang=js"
import style0 from "./AppointmentProgress.vue?vue&type=style&index=0&id=15a45290&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports